import type {FormRequest} from 'src/api/ProactApiClient';
import {offlineDb} from 'src/offline/db';
import {getActiveSession} from 'src/offline/offlineSessionManager';
import {PENDING_STATUSES} from 'src/offline/outbox';
import {FORM_OUTBOX_KINDS} from './localFiles';
import {FORMS_CONTEXT_KEY} from './snapshotKeys';

// Assignment ids whose Assigned Form submission is queued here — the tasks
// surfaces render those rows as pending without reading the forms outbox.
export const pendingFormAssignmentIds = async (): Promise<Set<number>> => {
  const session = await getActiveSession(FORMS_CONTEXT_KEY);
  if (!session) return new Set();
  const items = await offlineDb.outbox
    .where('sessionId')
    .equals(session.id)
    .toArray();
  const ids = items
    .filter(
      item =>
        item.kind === FORM_OUTBOX_KINDS.create &&
        PENDING_STATUSES.includes(item.status)
    )
    .map(item => Number((item.payload as FormRequest).metadata?.taskAssignmentId))
    .filter(id => Number.isFinite(id) && id > 0);
  return new Set(ids);
};
